type OptimisticAction<T> = {
  optimisticUpdate: () => void;
  apiCall: () => Promise<T>;
  rollback: () => void;
};

export async function performOptimisticAction<T>({ optimisticUpdate, apiCall, rollback }: OptimisticAction<T>) {
  optimisticUpdate();
  try {
    return await apiCall();
  } catch (error) {
    rollback();
    throw error;
  }
}
